import OfferBookConsultationButton from '@components/Button/OfferBookConsultationButton';
import OfferContactDialogForm from '@components/Dialog/OfferContactDialogForm';
import { useSidebar } from '@layout/Sidebar/SidebarContext';
import { Button } from '@eye-able/ui';
import { SendIcon } from 'lucide-react';

import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';

export function FloatingDemoOfferActions() {
  const { isMobile, openMobile } = useSidebar();
  const { t } = useInlineTranslation();

  const shouldShow = isMobile && !openMobile;

  if (!shouldShow) return null;

  return (
    <div className='eye:fixed eye:bottom-0 eye:left-0 eye:z-1150 eye:flex eye:w-full eye:flex-col eye:divide-y'>
      <OfferBookConsultationButton
        size='sm'
        variant='yellow'
        className='eye:rounded-none'
      />
      <OfferContactDialogForm
        trigger={
          <Button size='sm' variant='yellow' className='eye:rounded-none'>
            <SendIcon aria-hidden />
            {t('OfferContactFormButton')}
          </Button>
        }
      />
    </div>
  );
}
